export default "__VITE_ASSET__9sFVj8z2__"